import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent } from '../utils/analytics';
import { CONSENT_CHANGE_EVENT, analyticsAllowed } from '../utils/cookieConsent';

/**
 * Componente invisible que escucha cambios de ruta y dispara
 * un evento `page_view` por cada navegación. Se monta una sola vez
 * dentro de `<Router>`.
 */
const RouteTracker = () => {
  const location = useLocation();
  const pathRef = useRef(location.pathname);
  pathRef.current = location.pathname;

  // Al aceptar las cookies se cuenta la página en la que se está
  useEffect(() => {
    const onConsent = () => {
      if (analyticsAllowed()) trackEvent('page_view', pathRef.current);
    };
    window.addEventListener(CONSENT_CHANGE_EVENT, onConsent);
    return () => window.removeEventListener(CONSENT_CHANGE_EVENT, onConsent);
  }, []);

  useEffect(() => {
    if (!location || !location.pathname) return;
    trackEvent('page_view', location.pathname);
  }, [location.pathname]);

  return null;
};

export default RouteTracker;
